import React, { useEffect, useState, useContext } from 'react';
import './ReanaliseNir.css';
import { useSamples } from '../../contexts/SamplesContext';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar/sidebar';
import { Stack, Typography, Box, Grid2} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import Buttons from '../../components/button';
import GenericImput from '../../components/text-imput';
import CircularProgress from "@mui/material/CircularProgress";
import DataTable from '../../components/results sample table/result-sample-table';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const ReanaliseNir = () => {
    
    const { samples, searchSamples } = useSamples();
    const [visibleSamples, setVisibleSamples] = useState(10);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [first, setFirst] = useState('');
    const [last, setLast] =useState('');

    const search = async () =>{
        if (!first || !last) {
            setError("Informe a identificação da amostra para realizar a busca.");
            return;
        }
        setError(null);
        setLoading(true);
        try {
            await searchSamples(first, last);
        } catch (error: any) {
            let errorMessage = "Ocorreu um erro inesperado.";
            if (error.response) {
                errorMessage = error.response.data?.message || "Erro ao buscar amostras.";
            } else if (error.message) {
                errorMessage = error.message;
            }
            setError(errorMessage);
        }
        setLoading(false);
    };

    const handleLoadMore = () => {
        setLoading(true);
        setVisibleSamples((prev) => prev + 10);
        setLoading(false);
    };

    return (
        <>
            <Header />
            <Sidebar />
            <Box className='reanalise-content'>
                <Box
                    className="reanalise-page-title"
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 2,
                        p: 2
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2,  }}>
                        <SvgIcon className="pedidos-title-icon" >
                            {<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.5 22.75H22.3059C23.4182 21.3983 24.1411 19.7691 24.3968 18.0374C24.6525 16.3057 24.4314 14.5371 23.7572 12.9216C23.083 11.3062 21.9813 9.90503 20.5705 8.86881C19.1597 7.83259 17.4931 7.20049 15.75 7.04047V3.5C15.75 3.03587 15.5656 2.59075 15.2374 2.26256C14.9092 1.93437 14.4641 1.75 14 1.75H8.75C8.28587 1.75 7.84075 1.93437 7.51256 2.26256C7.18437 2.59075 7 3.03587 7 3.5V14.875C7 15.3391 7.18437 15.7842 7.51256 16.1124C7.84075 16.4406 8.28587 16.625 8.75 16.625H14C14.4641 16.625 14.9092 16.4406 15.2374 16.1124C15.5656 15.7842 15.75 15.3391 15.75 14.875V8.80031C17.2937 8.97334 18.7518 9.59905 19.9408 10.5987C21.1298 11.5984 21.9965 12.9274 22.432 14.4185C22.8675 15.9096 22.8523 17.4962 22.3883 18.9787C21.9243 20.4612 21.0322 21.7733 19.8242 22.75H3.5C3.26794 22.75 3.04538 22.8422 2.88128 23.0063C2.71719 23.1704 2.625 23.3929 2.625 23.625C2.625 23.8571 2.71719 24.0796 2.88128 24.2437C3.04538 24.4078 3.26794 24.5 3.5 24.5H24.5C24.7321 24.5 24.9546 24.4078 25.1187 24.2437C25.2828 24.0796 25.375 23.8571 25.375 23.625C25.375 23.3929 25.2828 23.1704 25.1187 23.0063C24.9546 22.8422 24.7321 22.75 24.5 22.75ZM14 14.875H8.75V3.5H14V14.875ZM7.875 20.125C7.64294 20.125 7.42038 20.0328 7.25628 19.8687C7.09219 19.7046 7 19.4821 7 19.25C7 19.0179 7.09219 18.7954 7.25628 18.6313C7.42038 18.4672 7.64294 18.375 7.875 18.375H14.875C15.1071 18.375 15.3296 18.4672 15.4937 18.6313C15.6578 18.7954 15.75 19.0179 15.75 19.25C15.75 19.4821 15.6578 19.7046 15.4937 19.8687C15.3296 20.0328 15.1071 20.125 14.875 20.125H7.875Z" fill="#1C5864"/>
                            </svg>
                            }
                        </SvgIcon>
                        <Typography className="reanalise-title-name" variant="h5">
                            Reanalise de Nitrogênio NIR
                        </Typography>
                    </Box>

                </Box>
                <Box className='search-content'>
                    <Box className='search-imputs'>
                             <GenericImput label="Amostra Inicial" placeholder="Amostra Inicial" type="text"
                                value={first}
                                onChange={(e) => setFirst(e.target.value)}
                                sx={{
                                    maxWidth: '500px', 
                                    '& .MuiInputBase-root': {
                                        backgroundColor: 'white',
                                        height: '40px', 
                                        borderRadius: '4px',
                                    },
                                    '& label': {
                                        fontSize: '14px',
                                        transform: 'translate(14px, 10px) scale(1)', 
                                    },
                                    '& label.Mui-focused, & label.MuiInputLabel-shrink': {
                                        transform: 'translate(14px, -12px) scale(0.75)', 
                                        padding: '0 4px',
                                        color: '#6b7280',
                                    },
                                    '& input:-webkit-autofill': {
                                        WebkitBoxShadow: '0 0 0 1000px white inset !important',
                                        WebkitTextFillColor: 'inherit !important',
                                    }
                                }} />
                            <GenericImput label="Amostra Final" placeholder="Amostra Final" type="text"
                                value={last}
                                onChange={(e) => setLast(e.target.value)}
                                sx={{
                                    maxWidth: '500px', 
                                    '& .MuiInputBase-root': {
                                        backgroundColor: 'white',
                                        height: '40px',
                                        borderRadius: '4px',
                                    },
                                    '& label': {
                                        fontSize: '14px',
                                        transform: 'translate(14px, 10px) scale(1)', 
                                    },
                                    '& label.Mui-focused, & label.MuiInputLabel-shrink': {
                                        transform: 'translate(14px, -12px) scale(0.75)', 
                                        padding: '0 4px',
                                        color: '#6b7280',
                                    },
                                    '& input:-webkit-autofill': {
                                        WebkitBoxShadow: '0 0 0 1000px white inset !important',
                                        WebkitTextFillColor: 'inherit !important',
                                    }
                                }}
                                />
                            <Box sx={{ margin: '20px', display: 'flex', justifyContent: 'center', justifyItems: 'center' }}>
                                <Buttons
                                    label="Buscar"
                                    onClick={search}
                                    backgroundColor="var(--primary-color)"
                                    isLoading={loading}
                                    disabled={loading}
                                    textColor="#fff"
                                    fullWidth={false}
                                    sx={{
                                        boxShadow: 'none',
                                        padding: '0.5rem 1rem',
                                        marginBottom: '0.5rem'
                                        }}
                                    />
                            </Box>
                    </Box> 
                    <Box>
                        {error && (
                            <Typography 
                                sx={{ 
                                    color: '#d32f2f', 
                                    fontSize: '0.75rem',
                                    fontWeight: 500,
                                    marginLeft: '10px'
                                }}
                            >
                            {error}
                            </Typography>
                        )}
                    </Box>           
                </Box>
                {/* Listagem das amostras */}
                 {loading ? (
                    <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />
                ) : (
                    <Grid2 container sx={{ marginLeft: '2%', paddingTop: '2px', marginRight: '5%', gap: 3 }}>
                        {samples !== null ? (
                            samples.length > 0 ? (
                                <Box sx={{ width: '100%', margin: '20px' }}>
                                    
                                    <DataTable 
                                        data={[...samples]
                                            .slice(0, visibleSamples)
                                        } 
                                    />
                                </Box>
                            ) : (
                                <Typography sx={{ m: 2 }}>Nenhuma amostra encontrada com esses parâmetros.</Typography>
                            )
                        ) : (
                            <Typography sx={{ m: 2, color: 'text.secondary', marginTop:'5%' }}>
                                Digite a idenfiticação das amostras para realizar a busca.
                            </Typography>
                        )}
                    </Grid2>
                )}

               {(samples?.length ?? 0) > visibleSamples && !loading && (
                    <Grid2 container className="more-button" justifyContent="center" alignItems="center">
                        <Buttons
                            label="Carregar mais amostras"
                            onClick={handleLoadMore}
                            backgroundColor="#fff"
                            borderColor="var(--primary-color)"
                            textColor="var(--primary-color)"
                            endicon={<ArrowForwardIcon />}
                            sx={{ width: "172px" }}
                        />
                    </Grid2>
                )}
            </Box>
        </>
    );
}
export default ReanaliseNir;